module.exports = "../../../../platform/assets/pageMainIcon/yewushezhilei8.svg";